(function () {
  'use strict';

  // ── 1. Scroll-freeze fix ─────────────────────────────────────────────────
  // MutationObserver: whenever cart-drawer loses 'active' class, unlock scroll
  function initScrollFix() {
    var cd = document.querySelector('cart-drawer');
    if (!cd) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class' && !cd.classList.contains('active')) {
          document.body.classList.remove('overflow-hidden');
          document.body.style.overflow = '';
        }
      }
    }).observe(cd, { attributes: true });
  }

  // Clear scroll lock on bfcache restore (back/forward nav)
  // Also refresh cart drawer contents so items added before checkout are visible
  window.addEventListener('pageshow', function (e) {
    document.body.classList.remove('overflow-hidden');
    document.body.style.overflow = '';

    if (e.persisted) {
      fetch('/cart?sections=cart-drawer,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          // Re-render drawer inner
          if (sections['cart-drawer']) {
            var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var newInner = parsed.querySelector('.drawer__inner');
            var curInner = document.querySelector('#CartDrawer .drawer__inner');
            if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
          }
          // Re-render cart icon bubble
          if (sections['cart-icon-bubble']) {
            var parsed2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var newBubble = parsed2.querySelector('.shopify-section');
            var curBubble = document.getElementById('cart-icon-bubble');
            if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
          }
          // Update is-empty state
          var cartDrawerEl = document.querySelector('cart-drawer');
          if (cartDrawerEl) cartDrawerEl.classList.remove('is-empty');
        })
        .catch(function () {});
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollFix);
  } else {
    initScrollFix();
  }

  // ── 2. Cart drawer button fix ────────────────────────────────────────────
  // Use capture-phase delegation so our handler runs before Dawn's.
  // We call /cart/change.js with sections in the body (same as Dawn) so the
  // response includes ready-to-render HTML — no second fetch needed.

  function getSections() {
    var cd = document.querySelector('cart-drawer');
    if (cd && typeof cd.getSectionsToRender === 'function') {
      return cd.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  async function doCartChange(line, quantity) {
    var body = JSON.stringify({
      line: parseInt(line, 10),
      quantity: parseInt(quantity, 10),
      sections: getSections(),
      sections_url: window.location.pathname
    });

    var res = await fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    });

    if (!res.ok) throw new Error('cart/change.js ' + res.status);
    var state = await res.json();

    // Re-render drawer inner HTML from section response
    var drawerSection = state.sections && state.sections['cart-drawer'];
    if (drawerSection) {
      var parsed = new DOMParser().parseFromString(drawerSection, 'text/html');
      var newInner = parsed.querySelector('.drawer__inner');
      var curInner = document.querySelector('#CartDrawer .drawer__inner');
      if (newInner && curInner) curInner.innerHTML = newInner.innerHTML;
    }

    // Re-render cart icon bubble
    var bubbleSection = state.sections && state.sections['cart-icon-bubble'];
    if (bubbleSection) {
      var parsed2 = new DOMParser().parseFromString(bubbleSection, 'text/html');
      var newBubble = parsed2.querySelector('.shopify-section');
      var curBubble = document.getElementById('cart-icon-bubble');
      if (newBubble && curBubble) curBubble.innerHTML = newBubble.innerHTML;
    }

    // Toggle empty state
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) cartDrawerEl.classList.toggle('is-empty', state.item_count === 0);
  }

  // Capture-phase: fires before Dawn's bubble-phase listeners
  document.addEventListener('click', function (e) {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer || !cartDrawer.contains(e.target)) return;

    // ── Trash / remove button ──────────────────────────────────────────────
    var removeEl = e.target.closest('cart-remove-button');
    if (removeEl) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var line = removeEl.dataset.index;
      if (!line) return;
      removeEl.style.opacity = '0.4';
      doCartChange(line, 0)
        .catch(function (err) { console.error('[nootro-cart-fix] remove:', err); })
        .finally(function () { removeEl.style.opacity = ''; });
      return;
    }

    // ── +/- quantity buttons ───────────────────────────────────────────────
    var qtyBtn = e.target.closest('.quantity__button');
    if (qtyBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var wrap = qtyBtn.closest('quantity-input') || qtyBtn.closest('.quantity');
      var input = wrap && wrap.querySelector('.quantity__input');
      if (!input) return;
      var line2 = input.dataset.index;
      if (!line2) return;
      var current = parseInt(input.value, 10) || 0;
      var newQty = Math.max(0, current + (qtyBtn.name === 'plus' ? 1 : -1));
      qtyBtn.disabled = true;
      doCartChange(line2, newQty)
        .catch(function (err) { console.error('[nootro-cart-fix] qty:', err); })
        .finally(function () { qtyBtn.disabled = false; });
      return;
    }
  }, true /* capture phase */);

})();
